;!function(){try{var e="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import { analytics } from '@/lib/analytics/posthog'

/**
 * Records a marketing CTA click. Autocapture is off, so without this we have no signal for which
 * CTA/section drives a signup. `location` is a stable slug (e.g. 'site-nav', 'hero', 'footer-cta');
 * `label` is the visible button text. All existing funnel events are unaffected.
 */
export function trackCta(location: string, label: string): void {
  analytics.capture('cta_clicked', { location, label })
}
